import { WhatsAppQrConnectDialog } from "@/components/integrations/WhatsAppQrConnectDialog";

interface WhatsAppBusinessConnectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  existingIntegration?: any;
  reconnectMode?: boolean;
  migrateFromIntegrationId?: string | null;
}

export function WhatsAppBusinessConnectDialog({
  open,
  onOpenChange,
  existingIntegration,
  reconnectMode,
  migrateFromIntegrationId,
}: WhatsAppBusinessConnectDialogProps) {
  const isMigrate = Boolean(migrateFromIntegrationId);

  return (
    <WhatsAppQrConnectDialog
      open={open}
      onOpenChange={onOpenChange}
      provider="whatsapp_uazapi"
      edgeFunction="uazapi-connect"
      title={isMigrate ? "Reconectar WhatsApp" : "Conectar WhatsApp Business"}
      description={
        isMigrate
          ? "Reconectando seu WhatsApp. Escaneie o QR code para continuar."
          : "Escaneie o QR code para conectar seu WhatsApp Business"
      }
      existingIntegration={existingIntegration}
      reconnectMode={reconnectMode}
      migrateFromIntegrationId={migrateFromIntegrationId}
    />
  );
}
